import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { MultiSelectDropdownModule } from 'NewAngular/features/components/dropdowns/multi-select-dropdown/multi-select-dropdown.module';
import { SingleSelectDropdownModule } from 'NewAngular/features/components/dropdowns/single-select-dropdown/single-select-dropdown.module';
import { HelpModalModule } from 'NewAngular/features/components/modals/help-modal/help-modal.module';
import { IconModule } from 'NewAngular/features/directives/icon/icon.module';
import { TooltipModule } from 'NewAngular/features/directives/popovers/tooltip/tooltip.module';
import * as i0 from "@angular/core";
export class ChartsSharedModule {
}
ChartsSharedModule.ɵfac = function ChartsSharedModule_Factory(__ngFactoryType__) { return new (__ngFactoryType__ || ChartsSharedModule)(); };
ChartsSharedModule.ɵmod = /*@__PURE__*/ i0.ɵɵdefineNgModule({ type: ChartsSharedModule });
ChartsSharedModule.ɵinj = /*@__PURE__*/ i0.ɵɵdefineInjector({ imports: [CommonModule,
        FormsModule,
        HelpModalModule,
        IconModule,
        MultiSelectDropdownModule,
        SingleSelectDropdownModule,
        TooltipModule] });
